<template>
  <m-pay-layout>
    <v-flex class="mx-2">

      <h2>About </h2>

      <div class="mt-4 mb-4 font-weight-bold grey--text ">
        <div>Frontend version:
          <span class="black--text">{{ formatDateTime(commitDate) }}</span>
          ("<span class="blue--text">{{commitMessage}}</span>")
          <span>{{ metaData.activeProfiles }}</span>
        </div>
      </div>

      <div class="mt-4 mb-4 font-weight-bold grey--text ">
        <div>Backend version:
          <span class="black--text">{{ formatters.dateTime(metaData.remoteDate) }}</span>
          ("<span class="blue--text">{{ metaData.remoteVersion }}</span>")
          <span>{{ metaData.remoteActiveProfiles }}</span>
        </div>
      </div>

    </v-flex>

  </m-pay-layout>
</template>

<script>
import axios from 'axios';
import moment from 'moment-timezone';
import formatters from '../utils/formatters';
import queries from '../utils/queries';
import MPayMessage from './MPayMessage';

export default {
  name: 'MPayAbout',

  component: [MPayMessage],

  data: () => ({
    user: {},
    loading: false,
    version: '',
    commitDate: '',
    commitHash: '',
    commitMessage: '',
    metaData: {},
    formatters,
  }),

  methods: {
    fetchVersion() {
      this.loading = true;
      axios.get(queries.version())
        .then((response) => {
          this.version = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
      axios.get(queries.commitHash())
        .then((response) => {
          const data = response.data;
          const chunks = data.split('\n');
          this.commitDate = chunks[0];
          this.commitHash = chunks[1];
          this.commitMessage = chunks[2];
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
      axios.get(queries.metaData())
        .then((response) => {
          this.metaData = response.data;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    formatDateTime(dateTime) {
      const truncated = dateTime.substring(0, 16);
      return moment(truncated, 'YYYY-MM-DD HH:mm')
        .format('DD.MM.YYYY HH:mm');
    },
  },

  mounted() {
    this.fetchVersion();
  },

};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/MPayAbout.vue